import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const downloadXlsx = (rows, baseName) => {
    const sheet = XLSX.utils.json_to_sheet(rows);
    const workbook = { Sheets: { data: sheet }, SheetNames: ['data'] };
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buffer], { type: FILE_TYPE }), `${baseName}.xlsx`);
};
